import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <AppSection />
        <AboutSection />
        <ContactSection />
        <TopicsSection />
        <UpdatesSection />
        <MediaSection />
        <IndexSection />
        <FaqSection />
        <CarouselSection />
        <CommentsSection />
        <CardsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}